import React, { useState, useEffect } from 'react';
import { Input, Button, Card, Tag, Spin, Alert, Row, Col, Typography } from 'antd';
import { SearchOutlined, CheckCircleOutlined, CloseCircleOutlined, ClockCircleOutlined, ExclamationCircleOutlined, CarOutlined, UserOutlined, BankOutlined, TeamOutlined } from '@ant-design/icons';
import Logo from '../../components/Logo';
import LogoOssanasur from '../../components/LogoOssanasur';
// import OssanAsurLogo fron '../../a'

const { Title, Text } = Typography;

const InsuranceVerification = () => {
    const [numeroPolice, setNumeroPolice] = useState('');
    const [contrat, setContrat] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Données de simulation
    const contratsSimulation = {
        'P-2024-12345': {
            numeroPoliceP: 'P-2024-12345',
            numeroPoliceM: 'M-2024-12345',
            dateEffet: '2024-01-15T00:00:00',
            dateEcheance: '2025-01-14T23:59:59',
            numeroAttestation: 'ATT-2024-001',
            numeroAttestationCedeao: 'CEDEAO-2024-001',
            primeTotale: 250000,
            suspendu: false,
            resilie: false,
            statutContrat: 'VALIDE',
            souscripteur: {
                nom: 'KOUAME',
                prenom: 'Jean-Paul',
                contact: ['+228 90 12 34 56'],
                email: 'jeanpaul.kouame@email.tg',
                adresse: 'Lomé, Tokoin',
                typePersonne: 'PHYSIQUE'
            },
            engins: [{
                immatriculation: 'TG-1234-AB',
                marque: 'Toyota',
                type: 'Corolla',
                numeroChassis: 'JTDKB20U203123456',
                dateMiseEnCirculation: '2020-03-15',
                energie: 'ESSENCE',
                nombrePlace: 5,
                usage: 'PRIVE',
                valeurDeclaree: 12000000,
                categorie: { nom: 'Véhicule de tourisme' }
            }],
            organisme: {
                raisonSociale: 'ASSURANCE GENERALE DU TOGO',
                contact: ['+228 22 21 23 45'],
                email: 'contact@agt.tg',
                siegeSocial: 'Lomé, Avenue de la Marina'
            },
            intermediaire: {
                nom: 'Cabinet AFRIQUE ASSURANCES',
                contact: ['+228 90 45 67 89']
            }
        }
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const nfcPolice = urlParams.get('police');

        if (nfcPolice) {
            setNumeroPolice(nfcPolice);
            rechercherContrat(nfcPolice);
        }
    }, []);

    const rechercherContrat = (police = numeroPolice) => {
        if (!police.trim()) {
            setError('Veuillez entrer un numéro de police valide');
            setContrat(null);
            return;
        }

        setLoading(true);
        setError(null);
        setContrat(null);

        setTimeout(() => {
            const contratTrouve = contratsSimulation[police];

            if (!contratTrouve) {
                setError(`Aucun contrat ne correspond au numéro de police : ${police}`);
                setLoading(false);
                return;
            }

            setContrat(contratTrouve);
            setLoading(false);
        }, 1500);
    };

    const getStatutInfo = () => {
        if (!contrat) return null;

        const dateEffet = new Date(contrat.dateEffet);
        const dateEcheance = new Date(contrat.dateEcheance);
        const maintenant = new Date();

        if (contrat.resilie) {
            return { icon: <CloseCircleOutlined />, text: 'RÉSILIÉ', color: '#ef4444', isValid: false };
        } else if (contrat.suspendu) {
            return { icon: <ExclamationCircleOutlined />, text: 'SUSPENDU', color: '#f59e0b', isValid: false };
        } else if (maintenant > dateEcheance) {
            return { icon: <ClockCircleOutlined />, text: 'EXPIRÉ', color: '#ef4444', isValid: false };
        } else if (maintenant < dateEffet) {
            return { icon: <ClockCircleOutlined />, text: 'EN ATTENTE', color: '#f59e0b', isValid: false };
        } else {
            return { icon: <CheckCircleOutlined />, text: 'VALIDE', color: '#22c55e', isValid: true };
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('fr-FR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    const formatCurrency = (amount) => {
        return amount.toLocaleString('fr-FR') + ' FCFA';
    };

    const statutInfo = getStatutInfo();

    const containerStyle = {
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #212466 0%, #1a1d4a 50%, #0f1129 100%)',
        padding: '24px',
        position: 'relative',
        overflow: 'hidden'
    };

    const floatingBgStyle = {
        position: 'fixed',
        top: '-50%',
        right: '-50%',
        width: '100%',
        height: '100%',
        background: 'radial-gradient(circle, rgba(135, 206, 250, 0.1) 0%, transparent 70%)',
        animation: 'float 20s ease-in-out infinite',
        pointerEvents: 'none'
    };

    const headerCardStyle = {
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '24px',
        padding: '40px',
        textAlign: 'center',
        marginBottom: '32px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
    };

    const searchCardStyle = {
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '24px',
        padding: '32px',
        marginBottom: '32px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
    };

    const glassCardStyle = {
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '24px',
        marginBottom: '24px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        transition: 'all 0.3s ease'
    };

    const vehicleCardStyle = {
        background: 'linear-gradient(135deg, rgba(135, 206, 250, 0.15) 0%, rgba(33, 36, 102, 0.15) 100%)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(135, 206, 250, 0.3)',
        borderRadius: '24px',
        marginBottom: '24px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        transition: 'all 0.3s ease'
    };

    const infoItemStyle = {
        background: 'rgba(255, 255, 255, 0.05)',
        padding: '16px',
        borderRadius: '12px',
        borderLeft: '4px solid #87CEEB',
        transition: 'all 0.3s ease',
        height: '100%'
    };

    const immatriculationStyle = {
        background: '#212466',
        color: '#87CEEB',
        padding: '12px 24px',
        borderRadius: '12px',
        fontWeight: 'bold',
        fontSize: '20px',
        letterSpacing: '2px',
        border: '2px solid #87CEEB',
        display: 'inline-block'
    };

    const nfcIconStyle = {
        fontSize: '60px',
        marginBottom: '16px',
        animation: 'pulse 2s ease-in-out infinite'
    };

    return (
        <div style={containerStyle}>
            <style>{`
        @keyframes float {
          0%, 100% { transform: translate(0, 0) rotate(0deg); }
          33% { transform: translate(30px, -30px) rotate(5deg); }
          66% { transform: translate(-20px, 20px) rotate(-5deg); }
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.05); opacity: 0.8; }
        }
        .glass-card-hover:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4) !important;
        }
        .info-item-hover:hover {
          background: rgba(255, 255, 255, 0.1) !important;
          transform: translateX(5px);
        }
      `}</style>

            <div style={floatingBgStyle}></div>

            <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
                {/* En-tête */}
                <div style={headerCardStyle}>
                    {/* <div style={nfcIconStyle}>📱</div> */}
                    <div style={{ background: "white", padding: "0px", borderRadius: "8px", maxWidth: "120px", margin: "0 auto", marginBottom: "16px", alignItems: "center" }}>
                        <Logo />
                    </div>
                    <Title level={1} style={{ color: '#fff', marginBottom: '8px', textShadow: '0 2px 10px rgba(0, 0, 0, 0.3)' }}>
                        Vérification d'Assurance Automobile
                    </Title>
                    <Text style={{ color: '#87CEEB', fontSize: '18px' }}>
                        Scannez votre carte NFC ou entrez votre numéro de police
                    </Text>
                </div>

                {/* Section de recherche */}
                <div style={searchCardStyle}>
                    <Row gutter={16}>
                        <Col xs={24} md={18}>
                            <Input
                                size="large"
                                value={numeroPolice}
                                onChange={(e) => setNumeroPolice(e.target.value)}
                                onPressEnter={() => rechercherContrat()}
                                placeholder="Entrez le numéro de police (ex: P-2024-12345)"
                                style={{
                                    borderRadius: '12px',
                                    fontSize: '16px',
                                    padding: '12px 20px',
                                    border: '2px solid transparent',
                                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)'
                                }}
                            />
                        </Col>
                        <Col xs={24} md={6}>
                            <Button
                                type="primary"
                                size="large"
                                icon={<SearchOutlined />}
                                onClick={() => rechercherContrat()}
                                loading={loading}
                                block
                                style={{
                                    background: 'linear-gradient(135deg, #87CEEB 0%, #4A90E2 100%)',
                                    border: 'none',
                                    borderRadius: '12px',
                                    height: '50px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    color: '#212466',
                                    boxShadow: '0 4px 15px rgba(135, 206, 250, 0.4)'
                                }}
                            >
                                Vérifier
                            </Button>
                        </Col>
                    </Row>
                </div>

                {/* Chargement */}
                {loading && (
                    <Card style={glassCardStyle} bordered={false}>
                        <div style={{ textAlign: 'center', padding: '40px' }}>
                            <Spin size="large" />
                            <div style={{ marginTop: '20px', color: '#87CEEB', fontSize: '18px' }}>
                                Vérification en cours...
                            </div>
                        </div>
                    </Card>
                )}

                {/* Erreur */}
                {error && !loading && (
                    <Alert
                        message="Contrat non trouvé"
                        description={error}
                        type="error"
                        showIcon
                        icon={<CloseCircleOutlined />}
                        style={{
                            background: 'rgba(248, 113, 113, 0.2)',
                            border: '1px solid rgba(248, 113, 113, 0.4)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '24px',
                            padding: '24px',
                            color: '#fff'
                        }}
                    />
                )}

                {/* Résultats */}
                {contrat && !loading && statutInfo && (
                    <div>
                        {/* Informations du contrat */}
                        <Card style={glassCardStyle} bordered={false} className="glass-card-hover">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid rgba(135, 206, 250, 0.3)', flexWrap: 'wrap', gap: '16px' }}>
                                <Title level={3} style={{ color: '#87CEEB', margin: 0, display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    📋 Informations du Contrat
                                </Title>
                                <Tag
                                    icon={statutInfo.icon}
                                    color={statutInfo.color}
                                    style={{
                                        padding: '8px 20px',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        borderRadius: '20px',
                                        animation: 'pulse 2s ease-in-out infinite'
                                    }}
                                >
                                    {statutInfo.text}
                                </Tag>
                            </div>

                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12} lg={8}>
                                    <div className="info-item-hover" style={infoItemStyle}>
                                        <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                            Numéro Police Principal
                                        </Text>
                                        <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                            {contrat.numeroPoliceP}
                                        </Text>
                                    </div>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <div className="info-item-hover" style={infoItemStyle}>
                                        <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                            Numéro Police Marché
                                        </Text>
                                        <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                            {contrat.numeroPoliceM || 'N/A'}
                                        </Text>
                                    </div>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <div className="info-item-hover" style={infoItemStyle}>
                                        <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                            Date d'Effet
                                        </Text>
                                        <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                            {formatDate(contrat.dateEffet)}
                                        </Text>
                                    </div>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <div className="info-item-hover" style={infoItemStyle}>
                                        <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                            Date d'Échéance
                                        </Text>
                                        <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                            {formatDate(contrat.dateEcheance)}
                                        </Text>
                                    </div>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <div className="info-item-hover" style={infoItemStyle}>
                                        <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                            N° Attestation
                                        </Text>
                                        <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                            {contrat.numeroAttestation}
                                        </Text>
                                    </div>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <div className="info-item-hover" style={infoItemStyle}>
                                        <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                            N° Attestation CEDEAO
                                        </Text>
                                        <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                            {contrat.numeroAttestationCedeao || 'N/A'}
                                        </Text>
                                    </div>
                                </Col>
                            </Row>
                        </Card>

                        {/* Souscripteur */}
                        <Card style={glassCardStyle} bordered={false} className="glass-card-hover">
                            <Title level={3} style={{ color: '#87CEEB', marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid rgba(135, 206, 250, 0.3)', display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <UserOutlined /> Souscripteur
                            </Title>

                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12}>
                                    <div className="info-item-hover" style={infoItemStyle}>
                                        <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                            Nom & Prénoms
                                        </Text>
                                        <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                            {contrat.souscripteur.nom} {contrat.souscripteur.prenom}
                                        </Text>
                                    </div>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <div className="info-item-hover" style={infoItemStyle}>
                                        <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                            Contact
                                        </Text>
                                        <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                            {contrat.souscripteur.contact.join(', ')}
                                        </Text>
                                    </div>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <div className="info-item-hover" style={infoItemStyle}>
                                        <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                            Email
                                        </Text>
                                        <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                            {contrat.souscripteur.email || 'N/A'}
                                        </Text>
                                    </div>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <div className="info-item-hover" style={infoItemStyle}>
                                        <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                            Adresse
                                        </Text>
                                        <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                            {contrat.souscripteur.adresse}
                                        </Text>
                                    </div>
                                </Col>
                            </Row>
                        </Card>

                        {/* Véhicules */}
                        {contrat.engins.map((engin, index) => (
                            <Card key={index} style={vehicleCardStyle} bordered={false} className="glass-card-hover">
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', flexWrap: 'wrap', gap: '16px' }}>
                                    <Title level={3} style={{ color: '#fff', margin: 0, display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <CarOutlined /> Véhicule {index + 1}
                                    </Title>
                                    <div style={immatriculationStyle}>
                                        {engin.immatriculation}
                                    </div>
                                </div>

                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={12} lg={8}>
                                        <div className="info-item-hover" style={infoItemStyle}>
                                            <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                                Marque & Type
                                            </Text>
                                            <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                                {engin.marque} {engin.type}
                                            </Text>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={12} lg={8}>
                                        <div className="info-item-hover" style={infoItemStyle}>
                                            <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                                N° Chassis
                                            </Text>
                                            <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                                {engin.numeroChassis}
                                            </Text>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={12} lg={8}>
                                        <div className="info-item-hover" style={infoItemStyle}>
                                            <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                                Énergie
                                            </Text>
                                            <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                                {engin.energie}
                                            </Text>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={12} lg={8}>
                                        <div className="info-item-hover" style={infoItemStyle}>
                                            <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                                Nombre de Places
                                            </Text>
                                            <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                                {engin.nombrePlace}
                                            </Text>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={12} lg={8}>
                                        <div className="info-item-hover" style={infoItemStyle}>
                                            <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                                Usage
                                            </Text>
                                            <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                                {engin.usage}
                                            </Text>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={12} lg={8}>
                                        <div className="info-item-hover" style={infoItemStyle}>
                                            <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                                Valeur Déclarée
                                            </Text>
                                            <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                                {formatCurrency(engin.valeurDeclaree)}
                                            </Text>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={12} lg={8}>
                                        <div className="info-item-hover" style={infoItemStyle}>
                                            <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                                Catégorie
                                            </Text>
                                            <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                                {engin.categorie.nom}
                                            </Text>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={12} lg={8}>
                                        <div className="info-item-hover" style={infoItemStyle}>
                                            <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                                Date Mise en Circulation
                                            </Text>
                                            <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                                {formatDate(engin.dateMiseEnCirculation)}
                                            </Text>
                                        </div>
                                    </Col>
                                </Row>
                            </Card>
                        ))}

                        {/* Compagnie d'assurance */}
                        <Card style={glassCardStyle} bordered={false} className="glass-card-hover">
                            <Title level={3} style={{ color: '#87CEEB', marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid rgba(135, 206, 250, 0.3)', display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <BankOutlined /> Compagnie d'Assurance
                            </Title>

                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12}>
                                    <div className="info-item-hover" style={infoItemStyle}>
                                        <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                            Dénomination Sociale
                                        </Text>
                                        <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                            {contrat.organisme.raisonSociale}
                                        </Text>
                                    </div>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <div className="info-item-hover" style={infoItemStyle}>
                                        <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                            Contact
                                        </Text>
                                        <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                            {contrat.organisme.contact.join(', ')}
                                        </Text>
                                    </div>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <div className="info-item-hover" style={infoItemStyle}>
                                        <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                            Email
                                        </Text>
                                        <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                            {contrat.organisme.email}
                                        </Text>
                                    </div>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <div className="info-item-hover" style={infoItemStyle}>
                                        <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                            Siège Social
                                        </Text>
                                        <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                            {contrat.organisme.siegeSocial}
                                        </Text>
                                    </div>
                                </Col>
                            </Row>
                        </Card>

                        {/* Intermédiaire */}
                        {contrat.intermediaire && (
                            <Card style={glassCardStyle} bordered={false} className="glass-card-hover">
                                <Title level={3} style={{ color: '#87CEEB', marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid rgba(135, 206, 250, 0.3)', display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <TeamOutlined /> Intermédiaire
                                </Title>

                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={12}>
                                        <div className="info-item-hover" style={infoItemStyle}>
                                            <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                                Dénomination Sociale
                                            </Text>
                                            <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                                {contrat.intermediaire.raisonSociale}
                                            </Text>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <div className="info-item-hover" style={infoItemStyle}>
                                            <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                                Contact
                                            </Text>
                                            <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                                {contrat.intermediaire.contact.join(', ')}
                                            </Text>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <div className="info-item-hover" style={infoItemStyle}>
                                            <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                                Email
                                            </Text>
                                            <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                                {contrat.intermediaire.email}
                                            </Text>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <div className="info-item-hover" style={infoItemStyle}>
                                            <Text style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                                                Siège Social
                                            </Text>
                                            <Text style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                                                {contrat.intermediaire.siegeSocial}
                                            </Text>
                                        </div>
                                    </Col>
                                </Row>
                            </Card>
                        )}
                    </div>
                )}
                {/* Powered by OssanAsur mention with the logo of ossanasur */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '24px' }}>
                    <span style={{ color: '#87CEEB', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                        Powered by OssanAsur
                    </span>
                    {/* <img src={OssanAsurLogo} alt="OssanAsur Logo" style={{ marginLeft: '8px' }} /> */}
                    <LogoOssanasur />
                </div>

            </div>
        </div>
    );
};

export default InsuranceVerification;